import { IdExtractor, type ThumbnailGetter, isHost } from "./ThumbnailGetter";

export class VimeoIdExtractor extends IdExtractor {
  get id() {
    const url = new URL(this.url);
    return url.pathname.split("/")[1];
  }

  static is(url: string) {
    return isHost(url, "vimeo.com");
  }
}

export class VimeoThumbnailGetter implements ThumbnailGetter {
  idExtractor: IdExtractor;
  constructor(url: string) {
    this.idExtractor = new VimeoIdExtractor(url);
  }

  fetchImgSrc() {
    return fetch(
      `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${this.idExtractor.id}`,
    )
      .then((res) => res.json())
      .then((res: any) => res.thumbnail_url as string);
  }
}
